import memoize from 'transmute/memoize';
import PortalIdParser from 'PortalIdParser';
import { getFlowEditRouteContextAware } from 'automation-ui-routing/utils';
import { getFullUrl } from 'hubspot-url-utils';
import BasePaths from 'automation-ui-routing/BasePaths';
import ActionConfigBasePaths from 'automation-ui-action-features/actions/ActionConfigBasePaths';
const PortalId = PortalIdParser.get();
export const getFlowEditActionRouteContextAware = memoize((flowId, action, revisionId, useFullUrl) => {
  const flowRevisionPath = getFlowEditRouteContextAware({
    flowId,
    revisionId,
    isEmbedded: false
  });
  const actionId = action.getActionId();
  const actionType = action.getActionType();
  const configRoute = actionType ? ActionConfigBasePaths[actionType] : null;
  if (useFullUrl) {
    return `${getFullUrl('app')}/workflows/${PortalId}${flowRevisionPath}/${BasePaths.PLATFORM_FLOW_CONFIGS}/${actionId}/${configRoute}`;
  }
  return `${flowRevisionPath}/${BasePaths.PLATFORM_FLOW_CONFIGS}/${actionId}/${configRoute}`;
}, (flowId, action, revisionId) => {
  return `${flowId}-${revisionId}-${action.getActionId()}`;
});